import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react'
import { useConversationStaffName } from '../useConversationStaffName'
import { StaffPersona } from '@features/personas/components/StaffPersona'

export function ConversationStaffTag({ node }: NodeViewProps) {
    const name = useConversationStaffName(String(node.attrs.id), node.attrs.label || String(node.attrs.id))
    return <NodeViewWrapper as="span" contentEditable={false}>
        <StaffPersona identifier={{ type: 'initials', value: String(node.attrs.id) }} dropDownZIndex={1000}
            hoverTarget={<span className="conversation-staff-tag">@{name}</span>} />
    </NodeViewWrapper>
}
